
import { useState, useEffect } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import RankingList from './components/RankingList';
import ComparisonTable from './components/ComparisonTable';
import SceneRecommendation from './components/SceneRecommendation';
import PointGuide from './components/PointGuide';
import CampaignSection from './components/CampaignSection';
import FAQ from './components/FAQ';
import ReturnGuide from './components/ReturnGuide';
import Footer from './components/Footer';
import Breadcrumb from '../../components/feature/Breadcrumb';

export default function HighReturnPage() {
  const [showFloatingCTA, setShowFloatingCTA] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowFloatingCTA(window.scrollY > 500);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    "name": "高還元率クレジットカード特集",
    "description": "ポイント還元率が高いクレジットカードを厳選紹介。基本還元率1%以上、特定店舗で最大7%還元など、お得にポイントが貯まるカードが見つかります。"
  };

  return (
    <div className="min-h-screen bg-white">
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }} />
      <Header />
      <Breadcrumb items={[
        { label: 'ホーム', path: '/' },
        { label: '高還元率' }
      ]} />
      <Hero />
      <RankingList />
      <ComparisonTable />
      <SceneRecommendation />
      <PointGuide />
      <CampaignSection />
      <FAQ />
      <ReturnGuide />
      <Footer />

      {/* スクロール追従CTA */}
      {showFloatingCTA && (
        <div className="fixed bottom-6 right-6 z-50 animate-bounce">
          <a
            href="#ranking"
            className="flex items-center gap-2 bg-[#DC2626] hover:bg-[#B91C1C] text-white font-bold px-6 py-4 rounded-full shadow-2xl transition-all cursor-pointer whitespace-nowrap"
          >
            <i className="ri-arrow-up-line"></i>
            おすすめカードを見る
          </a>
        </div>
      )}
    </div>
  );
}
